<template>
  <div class="radio-button" @click="choose">
    <input
      type="radio"
      :value="rValue"
      class="radio-button__input"
      v-model="rModel"
    />

    <div class="radio-button__fake"></div>

    <div class="radio-button__content"><slot /></div>
  </div>
</template>

<script>
export default {
  name: "RadioButton",

  props: {
    rValue: {
      type: String,
      default: null
    },

    value: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      rModel: this.$props.value
    };
  },

  methods: {
    choose() {
      this.rModel = this.rValue;
    }
  },

  watch: {
    rModel() {
      this.$emit("input", this.rModel);
    },

    value(model) {
      this.rModel = model;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@v2/app/styles/mixins";
@import "@v2/app/styles/media";

.radio-button {
  display: inline-flex;
  cursor: pointer;

  &__input {
    display: none;
  }

  &__fake {
    width: 24px;
    height: 24px;

    border-radius: 50%;
    background-color: #ffffff;
    border: 1px solid #cdced0;

    box-sizing: border-box;

    flex-shrink: 0;

    position: relative;
  }

  &__input:checked + &__fake {
    &::after {
      content: "";
      display: block;

      width: 10px;
      height: 10px;
      border-radius: 12px;

      background-color: #0070d2;

      @include centerAbsolutely();
    }
  }

  &__content {
    margin-left: 12px;
    margin-top: 5px;
  }
}
</style>
